import { relayStylePagination } from '@apollo/client/utilities';

export default {
  Comment: {
    fields: {
      reactions: { merge: false },
    },
  },
  CommentFields: {
    fields: {
      reactions: { merge: false },
    },
  },
  CommentThread: {
    fields: {
      comments: { merge: false },
    },
  },
  CreateTestOrganizationResult: {
    fields: {
      testUsers: { merge: false },
    },
  },
  CurrentUser: {
    fields: {
      sections: { merge: false },
    },
  },
  ExternalSearchPlatform: {
    fields: {
      installModes: { merge: false },
    },
  },
  Group: {
    fields: {
      allUsers: { merge: false },
      children: { merge: false },
      members: { merge: false },
      membershipTopics: { merge: false },
      owners: { merge: false },
      parents: { merge: false },
      requestors: { merge: false },
    },
  },
  History: {
    fields: {
      annotations: { merge: false },
      authors: { merge: false },
      threads: { merge: false },
    },
  },
  InsightMetrics: {
    fields: {
      metrics: { merge: false },
    },
  },
  IntegrationSettings: {
    fields: {
      enabledParents: { merge: false },
      enabledSearchSources: { merge: false },
      syncingRepos: { merge: false },
    },
  },
  Mention: {
    fields: {
      participants: { merge: false },
      tags: { merge: false },
    },
  },
  MentionContentHighlights: {
    fields: {
      highlights: { merge: false },
    },
  },
  Mutation: {
    fields: {
      deleteHistories: { merge: false },
      importFiles: { merge: false },
      markNotifications: { merge: false },
      reorderTopics: { merge: false },
    },
  },
  Organization: {
    fields: {
      customDomains: { merge: false },
      groups: { merge: false },
      integrations: { merge: false },
      invitations: { merge: false },
      posts: { merge: false },
      provisions: { merge: false },
      sections: { merge: false },
      series: { merge: false },
      topics: { merge: false },
      users: { merge: false },
      webhooks: { merge: false },
    },
  },
  OrganizationSettings: {
    fields: {
      allowedEmbedHosts: { merge: false },
    },
  },
  OrganizationSettingsPublic: {
    fields: {
      links: { merge: false },
      sectionIds: { merge: false },
    },
  },
  Post: {
    fields: {
      annotations: { merge: false },
      backlinks: { merge: false },
      contributions: { merge: false },
      contributors: { merge: false },
      histories: { merge: false },
      thanks: { merge: false },
      threads: { merge: false },
      topics: { merge: false },
      verificationEntries: { merge: false },
      viewers: { merge: false },
    },
  },
  PostActivity: {
    fields: {
      actors: { merge: false },
    },
  },
  PostDirectShare: {
    fields: {
      draftLinkEditorIds: { merge: false },
      editorGroupIds: { merge: false },
      editorIds: { merge: false },
      viewerGroupIds: { merge: false },
      viewerIds: { merge: false },
    },
  },
  PostFields: {
    fields: {
      annotations: { merge: false },
      threads: { merge: false },
      topics: { merge: false },
    },
  },
  PostInsights: {
    fields: {
      edits: { merge: false },
      metrics: { merge: false },
      reads: { merge: false },
    },
  },
  PostSearchResult: {
    fields: {
      ancestors: { merge: false },
    },
  },
  Provision: {
    fields: {
      favorites: { merge: false },
      members: { merge: false },
    },
  },
  PublicComment: {
    fields: {
      reactions: { merge: false },
    },
  },
  PublicCommentThread: {
    fields: {
      comments: { merge: false },
    },
  },
  PublicOrganization: {
    fields: {
      ssoPlatforms: { merge: false },
    },
  },
  PublicOrganizationSettings: {
    fields: {
      allowedEmbedHosts: { merge: false },
    },
  },
  PublicPost: {
    fields: {
      annotations: { merge: false },
      threads: { merge: false },
      topics: { merge: false },
    },
  },
  PublicReactionThread: {
    fields: {
      reactions: { merge: false },
    },
  },
  PublicSearchResultConnection: {
    fields: {
      ancestorIds: { merge: false },
    },
  },
  PublicSection: {
    fields: {
      items: { merge: false },
    },
  },
  PublicSeries: {
    fields: {
      posts: { merge: false },
    },
  },
  PublicTopic: {
    fields: {
      ancestors: { merge: false },
      children: { merge: false },
      descendants: relayStylePagination(),
      posts: { merge: false },
    },
  },
  Query: {
    fields: {
      activities: relayStylePagination(),
      auditLogs: relayStylePagination([
        "endDate",
        "startDate",
        "types",
        "user",
      ]),
      customDomains: { merge: false },
      externalPostPlatforms: { merge: false },
      externalSearch: { merge: false },
      externalSearchPlatforms: { merge: false },
      externalSearchSources: { merge: false },
      gitRepos: { merge: false },
      insightLeaderboard: relayStylePagination([
        "endDate",
        "groupId",
        "startDate",
        "topicId",
        "type",
      ]),
      insightTopPosts: relayStylePagination([
        "endDate",
        "groupId",
        "orderBy",
        "startDate",
        "topicId",
      ]),
      insightTopSearches: relayStylePagination([
        "endDate",
        "groupId",
        "orderBy",
        "startDate",
        "type",
      ]),
      integrations: { merge: false },
      invitations: { merge: false },
      listPosts: relayStylePagination([
        "filters",
        "platform",
        "sortBy",
        "topicId",
        "topicIds",
        "userId",
      ]),
      listTopics: relayStylePagination(["parentId"]),
      listUsers: relayStylePagination(["isDeactivated", "types"]),
      mcpSearch: { merge: false },
      mentionParents: { merge: false },
      notifications: relayStylePagination(),
      postActivities: { merge: false },
      posts: { merge: false },
      provisions: { merge: false },
      publicPosts: { merge: false },
      publicSearch: relayStylePagination(["query"]),
      publicSections: { merge: false },
      search: relayStylePagination(["filter", "query"]),
      searchTypes: { merge: false },
      sections: { merge: false },
      serieses: { merge: false },
      topicActivities: { merge: false },
      topics: { merge: false },
      unreadNotifications: relayStylePagination(),
      webhooks: { merge: false },
    },
  },
  ReactionThread: {
    fields: {
      reactions: { merge: false },
    },
  },
  RootPostFields: {
    fields: {
      topics: { merge: false },
    },
  },
  Section: {
    fields: {
      items: { merge: false },
    },
  },
  Series: {
    fields: {
      posts: { merge: false },
    },
  },
  SeriesFields: {
    fields: {
      posts: { merge: false },
    },
  },
  SlimPost: {
    fields: {
      topics: { merge: false },
    },
  },
  SlimPostFields: {
    fields: {
      topics: { merge: false },
    },
  },
  Subscription: {
    fields: {
      notificationsUpdated: { merge: false },
    },
  },
  Topic: {
    fields: {
      activities: relayStylePagination(),
      ancestors: { merge: false },
      children: { merge: false },
      descendants: relayStylePagination(),
      inheritedAncestors: { merge: false },
      memberGroups: { merge: false },
      members: { merge: false },
      ownerGroups: { merge: false },
      owners: { merge: false },
      pinnedPostIds: { merge: false },
      postCounts: { merge: false },
      posts: relayStylePagination(["orderBy", "type"]),
      requestors: { merge: false },
    },
  },
  TopicActivity: {
    fields: {
      actors: { merge: false },
    },
  },
  TopicFields: {
    fields: {
      ancestors: { merge: false },
      children: { merge: false },
    },
  },
  TopicMembership: {
    fields: {
      memberGroupIds: { merge: false },
      memberUserIds: { merge: false },
      ownerGroupIds: { merge: false },
      ownerUserIds: { merge: false },
      requestorUserIds: { merge: false },
    },
  },
  TopicSearchResult: {
    fields: {
      ancestors: { merge: false },
    },
  },
  User: {
    fields: {
      identities: { merge: false },
      membershipGroups: { merge: false },
      membershipTopics: { merge: false },
    },
  },
  UserSidebarSettings: {
    fields: {
      myTopicIds: { merge: false },
      sectionIds: { merge: false },
    },
  },
  Verification: {
    fields: {
      secondaryVerifiers: { merge: false },
    },
  },
  Webhook: {
    fields: {
      events: { merge: false },
      topics: { merge: false },
    },
  },
};
